import PropTypes from 'prop-types';
import ProductListSpecificationsModal from '@app/components/common/ProductListSpecificationsModal';
import { useSelector } from 'react-redux';
import { USER_TYPE_GUEST } from '@app/constants/commonConstants';

const ProductListSpecificationsModalContainer = ({
  title,
  removeCurrentModal,
  appliedFacets,
  bucketModelNumberFacet,
  showSpecificationsToggle,
  queryActionParam,
  productCardExpanded,
  isModal,
  showLeftNav
}) => {
  const currentCategory = useSelector(s => s.plpUI.current);
  const expandedId = useSelector(s => s.plpUI.expandedId);
  const sortBy = useSelector(s => s.plpUI.sortBy);
  const activeFacets = useSelector(s => s.plpUI.activeFacets);
  const facets = useSelector(
    s => s.categories.byId[currentCategory]?.facets || []
  );
  const plpDetailsStatus = useSelector(s => s.plpUI.getPlpDetailsStatus);
  const userType = useSelector(s => s.common?.userType);
  const isLoggedIn = userType !== null && userType !== USER_TYPE_GUEST;
  const unitOfMeasure = useSelector(s =>
    isLoggedIn
      ? s.shoppingPreferences?.shoppingPreferencesData.uom
      : s.plpUI.unitOfMeasure
  );

  return (
    <ProductListSpecificationsModal
      title={title}
      orderBy={sortBy}
      removeCurrentModal={removeCurrentModal}
      appliedFacets={appliedFacets}
      facets={facets}
      bucketModelNumberFacet={bucketModelNumberFacet}
      showSpecificationsToggle={showSpecificationsToggle}
      queryActionParam={queryActionParam}
      setExpanded={productCardExpanded}
      unitOfMeasure={unitOfMeasure}
      expandedId={expandedId}
      showLeftNav={showLeftNav}
      activeFacets={activeFacets}
      isModal={isModal}
      detailsStatus={plpDetailsStatus}
    />
  );
};
export default ProductListSpecificationsModalContainer;
ProductListSpecificationsModalContainer.propTypes = {
  appliedFacets: PropTypes.shape({
    current: PropTypes.arrayOf(
      PropTypes.shape({
        count: PropTypes.number,
        facet: PropTypes.string,
        label: PropTypes.string,
        uom: PropTypes.string
      })
    )
  }),
  title: PropTypes.string.isRequired,
  removeCurrentModal: PropTypes.func,
  queryActionParam: PropTypes.func,
  isModal: PropTypes.bool,
  bucketModelNumberFacet: PropTypes.bool,
  showSpecificationsToggle: PropTypes.bool,
  showLeftNav: PropTypes.bool,
  productCardExpanded: PropTypes.func
};
